import { format } from 'date-fns';

const escapeCsvValue = (value) => {
  if (value === null || value === undefined) return '';
  return `"${String(value).replace(/"/g, '""')}"`;
};

export const downloadCsv = (rows) => {
  const header = ['userEmail', 'userName', 'address', 'apartmentNumber', 'resourceType'];
  const csv = [
    header.join(','),
    ...rows.map((row) => header.map((key) => escapeCsvValue(row[key])).join(',')),
  ].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `booking-history-${format(new Date(), 'yyyy-MM')}.csv`;
  link.click();
  window.URL.revokeObjectURL(url);
};
